export default __webpack_public_path__ + "8b13757f5e43e1028ba5cc95b2816fbb.png";